import { render, staticRenderFns } from "./agent_accostats_manv1.vue?vue&type=template&id=01388511&scoped=true"
import script from "./agent_accostats_manv1.vue?vue&type=script&lang=js"
export * from "./agent_accostats_manv1.vue?vue&type=script&lang=js"
import style0 from "./agent_accostats_manv1.vue?vue&type=style&index=0&id=01388511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01388511",
  null
  
)

export default component.exports